module.exports = __webpack_public_path__ + "static/media/logo_csc.0046c554.svg";